export default __webpack_public_path__ + "static/media/empty-cart 1.173fa959.svg";